import { api } from "./users";

export const getAgentCabinetMe = async () => {
  const response = await api.get("/agent/me/");
  return response.data;
};

export const getAgentCabinetBookings = async (params = {}) => {
  const response = await api.get("/agent/bookings/", { params });
  return response.data;
};

export const getAgentCabinetReconciliation = async ({ year, month }) => {
  const response = await api.get("/agent/reconciliation/", {
    params: { year, month },
  });
  return response.data;
};

export const downloadAgentCabinetReconciliationExcel = async ({ year, month }) => {
  const response = await api.get("/agent/reconciliation/export/", {
    params: { year, month },
    responseType: "blob",
  });
  return response;
};
